export default __webpack_public_path__ + "static/media/logoLine.438c6ffd.webp";